// Libraries
import React, { Component } from "react";
import PropTypes from "prop-types";
import GoogleMapReact from "google-map-react";

// Config
import { mapStyle } from "../../utils/scripts/map";

// Constants
const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

class Map extends Component {
  constructor() {
    super();
    this.handleGoogleMapApi = this.handleGoogleMapApi.bind(this);

    this.state = {
      google: undefined,
      service: undefined,
      line: undefined,
      refrence: undefined,
      refrence_lat: "",
      refrence_long: "",
    };
  }

  static defaultProps = {
    center: {
      lat: 51.0504,
      lng: 13.7273,
    },
    zoom: 14,
  };

  // Update the priority after selcting the Poi
  async componentDidUpdate(prevProps, prevState) {
    // console.log("prevstate", prevState);
    // console.log("state", this.state);
    // console.log("prevProps", prevProps);
    // console.log("props", this.props);

    if (this.state.google !== prevState.google) {
      if (prevProps.lat && prevProps.long && prevProps.refrence) {
        // Draw initial line
        this.handleDrawLine();

        this.handleMapReCenter();
      }
    }

    if (this.state.google) {
      // Load Map in Viewpoint Form
      if (prevProps.refrence !== this.props.refrence) {
        const refrence = this.props.refrence;

        this.setState({
          refrence: refrence,
          refrence_lat: refrence.lat,
          refrence_long: refrence.long,
        });

        this.handleMapReCenter();

        // Calculate Degree from North
        // this.calcDegreeToPoint(this.props.lat, this.props.long);

        // Calculate Distance between two points
        // this.handleCalculateDistance();
      }

      // Load Map in Viewpoint Table
      if (this.props.table) {
        if (!this.state.refrence) {
          const refrence = this.props.refrence;

          this.setState({
            refrence: refrence,
            refrence_lat: refrence.lat,
            refrence_long: refrence.long,
          });

          // Draw initial line
          this.handleDrawLine();

          this.handleMapReCenter();
        }
      }

      // Initial Viewpoint Form
      if (prevState.refrence !== this.state.refrence) {
        // Draw initial Line
        this.handleDrawLine();

        // Remove initial Line after Map is clicked
        this.handleRemoveLine();
      }

      // Viewpoint Form after Click
      if (
        prevProps.lat !== this.props.lat ||
        prevProps.long !== this.props.long
      ) {
        if (this.state.refrence) {
          // Remove previous Line when Map is clicked for second time
          this.handleRemoveLine();

          // Draw line after map is clicked
          this.handleDrawLine();

          // Calculate Distance between two points
          this.getDistance();

          // Calculate Degree from North
          this.calcDegreeToPoint(this.props.lat, this.props.long);
        }
      }
    }
  }

  // When Map loaded
  handleGoogleMapApi = (google) => {
    this.setState({ google: google });
  };

  // Recenter and Zoom
  handleMapReCenter = () => {
    const { google } = this.state;
    const { lat, long, refrence } = this.props;

    // New center of Zoom chaning
    const center_lat = (lat + refrence.lat) / 2;
    const center_long = (long + refrence.long) / 2;
    const laLatLng = new google.maps.LatLng(center_lat, center_long);

    // Amount of Zoom Changing
    const latDiff = Math.abs(lat - refrence.lat);
    const longDiff = Math.abs(long - refrence.long);
    const zoomFactor = (latDiff + longDiff) * 1000;

    google.map.panTo(laLatLng);
    google.map.setZoom(19 - zoomFactor);
  };

  // Draw Line between Two Markers
  handleDrawLine = () => {
    const { lat, long, refrence } = this.props;
    const { google, refrence_lat: refLat, refrence_long: refLong } = this.state;
    const refrence_lat = refrence ? refrence.lat : refLat;
    const refrence_long = refrence ? refrence.long : refLong;

    // Arrow Shape
    const lineSymbol = {
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      strokeColor: "#337ab7",
      strokeOpacity: 1,
      strokeWeight: 3,
    };

    // Line
    const line = new google.maps.Polyline({
      path: [
        { lat: lat, lng: long },
        { lat: refrence_lat, lng: refrence_long },
      ],
      geodesic: true,
      strokeColor: "#337ab7",
      strokeOpacity: 1,
      strokeWeight: 3,
      icons: [
        {
          icon: lineSymbol,
          offset: "100%",
        },
      ],
    });

    this.setState({ line: line });

    line.setMap(google.map);
  };

  // Remove Previous Line between Two Markers
  handleRemoveLine = () => {
    const state = { ...this.state };

    if (state.line) {
      state.line.setMap(null);
    }
  };

  // Calculation of distance betwwen points
  handleCalculateDistance = () => {
    const { google, line } = this.state;

    // Get Distance base on meters
    const distance = google.maps.geometry.spherical.computeLength(
      line.getPath()
    );

    // Round distance value for milimetrs
    const rounded_distance = Math.round(distance * 1000) / 1000;

    this.props.getDistance(rounded_distance);
  };

  // JavaScript program to calculate Distance Between
  // Two Points on Earth

  getDistance = () => {
    const { lat, long } = this.props;
    const { refrence_lat, refrence_long } = this.state;

    // Degrees to Radians
    const lat_degree = (lat * Math.PI) / 180;
    const long_degree = (long * Math.PI) / 180;
    const refrence_lat_degree = (refrence_lat * Math.PI) / 180;
    const refrence_long_degree = (refrence_long * Math.PI) / 180;

    // Differences in Radians
    const longitude_distance = refrence_long_degree - long_degree;
    const latitude_distance = refrence_lat_degree - lat_degree;

    // Haversine Formula
    const amount =
      Math.pow(Math.sin(latitude_distance / 2), 2) +
      Math.cos(lat_degree) *
        Math.cos(refrence_lat_degree) *
        Math.pow(Math.sin(longitude_distance / 2), 2);

    const value = 2 * Math.asin(Math.sqrt(amount));

    // Radius of Earth in Kilometers: 6371
    const radius = 6371;

    //Each Kilometer is: 1000 meters
    const distance = value * radius * 1000;

    // Round Distance value for Centimeters
    const rounded_distance = Math.round(distance * 100) / 100;

    this.props.getDistance(rounded_distance);
  };

  // Orientation to Poi
  calcDegreeToPoint = (latitude, longitude) => {
    const { refrence_lat, refrence_long } = this.state;

    const phiK = (refrence_lat * Math.PI) / 180.0;
    const lambdaK = (refrence_long * Math.PI) / 180.0;

    const phi = (latitude * Math.PI) / 180.0;
    const lambda = (longitude * Math.PI) / 180.0;

    const psi =
      (180.0 / Math.PI) *
      Math.atan2(
        Math.sin(lambdaK - lambda),
        Math.cos(phi) * Math.tan(phiK) -
          Math.sin(phi) * Math.cos(lambdaK - lambda)
      );

    // calculate reagrding the north (pointdegree = 0 : North)
    let pointDegree = Math.round(psi);
    if (pointDegree < 0) {
      pointDegree = pointDegree + 360;
    }

    // return pointDegree;
    this.props.getDegree(pointDegree);
  };

  render() {
    const {
      lat,
      long,
      style,
      onClick,
      zoom,
      center = [lat, long],
      refrence,
      table,
    } = this.props;

    function createMapOptions(maps) {
      return {
        zoomControlOptions: {
          position: maps.ControlPosition.LEFT_TOP,
          style: maps.ZoomControlStyle.SMALL,
        },
        mapTypeControlOptions: {
          position: maps.ControlPosition.TOP_RIGHT,
          style: maps.ZoomControlStyle.SMALL,
        },
        mapTypeControl: (refrence ? true : false) ^ table,
        streetViewControl: true,
        styles: mapStyle,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: true,
        disableDoubleClickZoom: true,
        draggableCursor: "crosshair",
        yesIWantToUseGoogleMapApiInternals: true,
      };
    }

    return (
      // Important! Always set the container height explicitly
      <div style={style}>
        <GoogleMapReact
          onClick={onClick}
          bootstrapURLKeys={{
            key: googleMapKey,
          }}
          defaultCenter={center}
          defaultZoom={zoom}
          options={createMapOptions}
          yesIWantToUseGoogleMapApiInternals
          onGoogleApiLoaded={this.handleGoogleMapApi}
        >
          {refrence && (
            <i
              className="bx bx-map bx-md map-pin"
              lat={refrence.lat}
              lng={refrence.long}
            ></i>
          )}
          <i
            className={
              refrence
                ? "bx bx-location-plus bx-md map-pin"
                : "bx bx-map bx-md map-pin"
            }
            lat={lat}
            lng={long}
          ></i>
        </GoogleMapReact>
      </div>
    );
  }
}

// Typechecking
Map.propTypes = {
  lat: PropTypes.number.isRequired,
  long: PropTypes.number.isRequired,
  zoom: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  getDistance: PropTypes.func,
  getDegree: PropTypes.func,
  refrence: PropTypes.object,
  table: PropTypes.bool,
};

export default Map;
